export function ToolLongForm({ howItWorks, benefits, tips }) {
    return (
        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-10">
            <section>
                <h2 className="text-xl md:text-2xl font-semibold tracking-tight text-slate-900">
                    How it works
                </h2>
                <div className="prose mt-4">
                    {howItWorks.map((para, i) => (
                        <p key={i}>{para}</p>
                    ))}
                </div>
            </section>
            <section>
                <h2 className="text-xl md:text-2xl font-semibold tracking-tight text-slate-900">
                    Why it matters
                </h2>
                <div className="prose mt-4">
                    {benefits.map((para, i) => (
                        <p key={i}>{para}</p>
                    ))}
                </div>
                {tips && tips.length > 0 ? (
                    <div className="mt-6 rounded-xl border border-border/70 bg-[hsl(var(--surface-2))] p-4">
                        <p className="text-sm font-semibold text-slate-900">Pro tips</p>
                        <ul className="mt-2 list-disc pl-5 space-y-1 text-sm text-slate-700">
                            {tips.map((t, i) => (
                                <li key={i}>{t}</li>
                            ))}
                        </ul>
                    </div>
                ) : null}
            </section>
        </div>
    );
}
